// extracted by mini-css-extract-plugin
export default {"root":"ScoreBar_root__-OXsI"};